export default __webpack_public_path__ + "static/media/goats.e33f088b.jpg";